<template>
  <div>
    <g-swiper
      :images="info.goodsBanners"
      prefix="imgUrl"
      :cusStyle="cusStyle"
    ></g-swiper>
    <div class="content c-p-20">
      <div class="c-fl-bt content-top">
        <div>
          <span class="c-yang c-tc" v-if="this.info.MarketPrice">￥</span>
          <span class="c-money c-p-r-10" v-if="this.info.MarketPrice">{{
            this.info.MarketPrice
          }}</span>
          <b class="c-sub-money" v-if="this.info.ScribePrice">
            <span class="">￥</span>{{ this.info.ScribePrice }}
          </b>
        </div>
        <div>
          <span class="is-sale">已售{{ this.info.Sales }}</span>
        </div>
      </div>
      <div class="title">{{ this.info.Name }}</div>
      <div class="add-box c-p-20">
        <div class="add-r">
          <div class="l" @click="goodsNumHandler('delete')">
            <g-img
              :src="require('@/assets/images/reduce_icon.png')"
              :size="50"
            ></g-img>
          </div>
          <div class="c">
            {{ this.goodsNum }}
          </div>
          <div class="r" @click="goodsNumHandler('add')">
            <g-img
              :src="require('@/assets/images/add_icon_active.png')"
              :size="50"
            ></g-img>
          </div>
        </div>
      </div>
    </div>
    <g-line></g-line>
    <div class="list c-p-20">
      <div>
        <span class="l-l">售后</span>
        <span class="l-r">{{
          info.IsAllowRefund ? "支持退款" : "不支持退款"
        }}</span>
      </div>
      <!-- <div>
        <span class="l-l">优惠</span>
        <span class="l-r">暖冬狂欢, 慢200减40, 活动仅限一天</span>
      </div> -->
    </div>
    <g-line></g-line>
    <goods-img-com
      :textInduction="info.Introduction"
      :imgInfo="info.introImgs"
    ></goods-img-com>
    <!-- <van-tabs
      v-if="list.length > 0"
      v-model="active"
      scrollspy
      sticky
      :color="$store.state.tc"
    >
      <van-tab v-for="index in list" :title="index" :key="index">
        <div class="tab_item_con">
          <div v-if="index == '简介'" class="tab_info_con">
            <p class="c-main-txt font-30 bold-600">商品简介</p>
            <p class="c-main-txt">BRIEF INTRODUCTION</p>
            <p class="m-tb-20">{{ info.Introduction }}</p>
          </div>
          <div v-else>
            <p class="c-main-txt font-30 bold-600">商品图文</p>
            <p class="c-main-txt">PICTURE TEXT</p>
            <ul class="tab_imgs_con">
              <li v-for="(imgItem, imgIndex) in info.introImgs" :key="imgIndex">
                <img :src="imgItem.imgUrl" alt="" />
              </li>
            </ul>
          </div>
        </div>
      </van-tab>
    </van-tabs> -->

    <van-goods-action>
      <!-- <van-goods-action-icon
        icon="star"
        text="收藏"
      /> -->
      <van-goods-action-icon
        icon="cart-o"
        text="购物车"
        :badge="badgeNum"
        @click="shoppingCard"
      />
      <van-goods-action-button
        color="#DCC494"
        text="加入购物车"
        @click="addShoppingCard"
      />
      <van-goods-action-button
        :color="$store.state.tc"
        @click="immediatelyBuy"
        text="立即购买"
      />
    </van-goods-action>
  </div>
</template>

<script>
import { getProductDetail } from "@/api/goods";
import { submitOrder } from "@/api/order";
import { isDuringDate } from "@/utils/index";
import goodsImgCom from "@/components/goodsImgCom";
export default {
  name: "SaleGoodsDetail",
  props: {},
  components: {
    goodsImgCom,
  },
  data() {
    return {
      productId: this.$route.params.id,
      goodsItem: [],
      badgeNum: null,
      images: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg",
      ],
      cusStyle: {
        height: "375px",
        // width: '375px',
      },
      list: ["简介", "图文"],
      // list: [],
      active: 0,
      goodsNum: 1,
      info: {
        // shortIntros: [],
        introImgs: [],
        Vpns: [],
        // storeName: '五指养生（五道口店）',
        // goodsName: '专业足疗+背部按摩+单人脊柱脊背形态调理',
        // storeAddress: '北京市海淀区信心清华东路16号宝源办公楼A4幢（以海大厦）三层23号',
        // storeTel: '010-25886868',
        // goodsValidTime: '2020.02.20-2020.04.21',
        // isCanRefund: false,
        // goodsPrice: '36.00',
        // discountAmount: '10.5',
        // goodsBanners: [
        //   {
        //     imgUrl: require('../../assets/goods_img.png')
        //   }
        // ],
        // shortIntros: [
        //   '适用门店：所有门店',
        //   '项目时长：2小时',
        //   '套餐详情：按摩、推拿、护理'
        // ],
        // introImgs: [
        //   {
        //     imgUrl: require('../../assets/goods_img.png')
        //   }
        // ]
      },
      isShowEmpty: false,
      isOnSale: true,
      isWeChatClient: true,
      userId: "", // 用户id，微信内置浏览器为openid，其他环境为系统的userId
      goodsCache: [],
    };
  },
  created() {
    this.init();
    this.goodsCache = this.$pub.getS("goodsCache") || [];
    if (this.goodsCache.length > 0) {
      this.goodsCache.forEach((v) => {
        this.badgeNum += v.goodsNum;
      });
    }
  },
  mounted() {},
  methods: {
    init() {
      // 判断浏览器环境
      const browserType = this.$store.state.browserType;
      if (browserType.shell === "wechat") {
        this.userId = localStorage.getItem("OpenId");
      } else {
        this.isWeChatClient = false;
      }
      // 获取产品详情
      getProductDetail({ query: { id: this.productId } }).then((res) => {
        if (res.Pager.TotalCount > 0) {
          const data = res.Items[0];
          // 产品简介
          // data.shortIntros = []
          // 产品图片
          data.goodsBanners = [];
          data.introImgs = [];
          const imgArr = data.Claims;
          if (imgArr instanceof Array && imgArr.length > 0) {
            imgArr.map((item) => {
              if (item.TypeId === 1) {
                data.goodsImgUrl = `${item.CdnUrl}/${item.Value}`;
              }
              if (item.TypeId === 1) {
                data.goodsBanners.push({
                  imgUrl: `${item.CdnUrl}/${item.Value}`,
                });
              }
              if (item.TypeId === 0) {
                data.introImgs.push({ imgUrl: `${item.CdnUrl}/${item.Value}` });
              }
            });
          }
          // 产品有效期
          if (data.IsAbsoluteExpirationDate) {
            // 绝对日期
            data.goodsValidTime = `${data.ExpirationStartDate}至${data.ExpirationEndDate}`;
          } else {
            // 相对日期
            data.goodsValidTime = `自购买日起${data.ExpirationDays}天内有效`;
          }
          // 产品的销售日期
          this.isOnSale = isDuringDate(
            data.SaleStartDate || "1990-1-1",
            data.SaleEndDate || "2099-12-31"
          );
          data.SalesTime = `${data.SaleStartDate}至${data.SaleEndDate}`;
          // 产品优惠金额
          if (data.MarketPrice > data.CostPrice) {
            // data.discountAmount = (data.MarketPrice - data.CostPrice).toFixed(2)
          }
          this.info = data;
        } else {
          this.isShowEmpty = true;
        }
      });
    },
    async immediatelyBuy() {
      let data = this.info;
      const goodsInfo = {
        imgUrl: data.goodsImgUrl,
        id: data.Id,
        name: data.Name,
        price: data.CostPrice,
        validTime: data.goodsValidTime,
        number: this.goodsNum,
        tenantId: data.TenantId,
      };
      this.$pub.setS("goodsInfo", goodsInfo);
      this.onSubmit();
    },
    async onSubmit() {
      this.$pub.setS("pageBeforeLogin", "submitOrder");
      this.goodsInfo = this.$pub.getS("goodsInfo");
      const requestParams = {
        Phone: this.$pub.getS("userPhone") || this.$store.state.OpenId,
        VpnId: this.$store.state.vpnId,
        Items: [
          {
            DistributorId: localStorage.getItem("distributorId"),
            ProductId: this.goodsInfo.id,
            Quantity: this.goodsInfo.number,
          },
        ],
      };
      const orderId = await submitOrder(requestParams);
      this.$store.commit("setStoreVal", { orderId: orderId });
      this.$router.push({
        name: "PayList",
        query: { id: orderId },
      });
    },
    shoppingCard() {
      this.$router.push("/goods/shoppingCard");
    },
    addShoppingCard() {
      this.badgeNum += this.goodsNum;
      this.pushGoodsCache();
    },
    pushGoodsCache() {
      let obj = this.$pub.deepClone(this.info);
      obj.goodsNum = this.goodsNum;
      if (this.goodsCache.length === 0) {
        this.goodsCache.push(obj);
      } else {
        let findIdx = this.goodsCache.findIndex((v, i) => {
          return v.Id === this.info.Id;
        });
        if (findIdx === -1) {
          this.goodsCache.push(obj);
        } else {
          this.goodsCache[findIdx].goodsNum += this.goodsNum;
        }
      }
      this.$pub.setS("goodsCache", this.goodsCache, true);
    },
    goodsNumHandler(handle, v, i) {
      if (handle === "add") {
        this.goodsNum++;
      }
      if (handle === "delete") {
        if (this.goodsNum === 1) {
          return this.$toast("购买数量不得低于1张");
        }
        this.goodsNum--;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 750px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px -8px 14px 0px rgba(0, 0, 0, 0.18);
  border-radius: 20px 20px 0px 0px;
  margin-top: -100px;
  z-index: 1000;
  position: relative;
}
.sale-price {
  font-size: 48px;
  font-weight: bold;
  font-family: Cochin-Bold, Cochin;
  color: var(--tc);
  margin-right: 10px;
}
.yang {
  color: var(--tc);
}
.is-sale {
  font-size: 24px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #888888;
}
.content-top {
  margin: 10px 0;
}
.title {
  font-size: 34px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.add-box {
  display: flex;
  flex-direction: row-reverse;
  .add-r {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .c {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}
.list {
  box-sizing: border-box;
  font-size: 26px;
  & > div {
    margin: 10px 0;
  }
  .l-l {
    font-weight: 400;
    color: #888888;
    margin-right: 20px;
  }
  .l-r {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.tab_item_con {
  padding: 30px;
  .tab_imgs_con {
    margin-top: 20px;
    li {
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
}
.origin-money {
  text-decoration: line-through;
}
</style>
